import 'custom-event-polyfill'; // Necessary for IE because Babel does not include it: https://github.com/zloirock/core-js/issues/354
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/fix-ios-sizes/fix-ios-sizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'media-match';
import './utils/themeEditor';

import * as Sentry from '@sentry/browser';
import * as routes from './routes';

import { Counter } from './modules/Counter';
import { DiscountInterface } from './CYOA/data/products';
import { GlobalShopifyObject } from './types/globals';
import { PostMessageClient } from './modules/share-storage';
import { Router } from './utils/Router';
import { SENTRY_ALLOWED_URLS } from './utils/errorLogger';
import { executeWhenDOMIsReady } from './utils/executeWhenDOMIsReady';
import { getEnv } from './config';
import { initEntryNarrationMessage } from './modules/A11y';

interface GlobalEmbarkShopObject {
  DOMRouter: Router;
  product: Record<string, any> | undefined;
  productDiscounts: Array<DiscountInterface>;

  customDNASavings?: Record<string, string>;
}

declare global {
  interface Window {
    Counter: any;
    reviewWidgetAttributes: Record<string, any> | undefined;
    starWidgetAttributes: Record<string, any> | undefined;
    embark: {
      shop: GlobalEmbarkShopObject;
      cartStore: PostMessageClient;
      config: Record<string, any>;
    };
    Shopify: GlobalShopifyObject;
    dataLayer: Record<string, any>[];
    theme?: {
      moneyFormat?: string;
    };
    FLAGS: Record<string, any>;
    _EMBARKVET_CURRENTLY_APPLIED_DISCOUNT_CODE?: string | null;
    lastClickedElement?: HTMLElement;
    IS_GALLERY_DRAGGING?: boolean;
    __IMAGE_GALLERY_VARIANT?: 'A';
    _cartDrawerOpenedBy?: Element | null;
    _modalOpenedBy?: Element | null;
  }
}

// Make the counter a globally available class.
window.Counter = Counter;

initEntryNarrationMessage();

Sentry.init({
  dsn: 'https://1572ac9834ce471f427b9276362dad0a@o405765.ingest.sentry.io/4506270365712384',
  environment: getEnv(),
  release: '__SENTRY_RELEASE__',
  allowUrls: SENTRY_ALLOWED_URLS,
});

executeWhenDOMIsReady(function () {
  const router = new Router(routes);
  window.embark.shop.DOMRouter = router;
  router.loadEvents();
});
